import mitt from 'mitt';
import { btnTd } from '@/api/typing';
import defaultSlotList from '@/components/page-model/slotList';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import { message } from 'ant-design-vue';

export const event_obj = mitt();
export const btn_list = null;
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};
export const head_btn_list = [
  // {
  //   name: '导出',
  //   clazz: 'primary',
  //   cb: (search_model: any) => {
  //     const current_org = ls.get(STORAGE_CURRENT_ORG_KEY);
  //     const payload: any = {
  //       org_id: current_org?.id,
  //       ...search_model,
  //     };
  //     let params_str = '';
  //     Object.keys(payload).forEach(key => {
  //       if (payload[key] != null && key != 'current' && key != 'pageSize') {
  //         params_str += key + '=' + payload[key] + '&';
  //       }
  //     });
  //     window.open(
  //       '/mjstore/query_staff_list?export=true&' + params_str + new Date().getTime(),
  //       '_blank',
  //     );
  //     message.success('导出成功');
  //   },
  // },
];
